import * as React from 'react';
import { RangeInput } from '../../../RangeInput';

export interface IFloorCountsFilterProps {
  floorCountFrom?: number;
  floorCountTo?: number;
  onChange(min: number | undefined, max: number | undefined): void;
}

export function FloorCountsFilter({ floorCountFrom, floorCountTo, onChange }: IFloorCountsFilterProps) {
  return (
    <RangeInput
      spliced
      maxWidth={120}
      min={0}
      max={99}
      valueMin={floorCountFrom}
      valueMax={floorCountTo}
      onChange={onChange}
    />
  );
}
